import React from 'react';
import CloseIcon from '../../../../icons/Close/CloseIcon';
import { FilterProps } from '../filter.util';
import { BaseFilter, BaseFilterProps } from '../BaseFilter';

export interface FilterInnerContentProps<T> {
  filter: BaseFilter<T>;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

interface DynamicFilterInnerContentProps<T> {
  items: string[];
  filter: BaseFilter<T>;
  filterProps: BaseFilterProps;
  text?: (item: string) => string;
  onRemove: (item: string) => void;
  label?: string;
}

export default function InnerFilterContent<T>({
  items,
  filter,
  filterProps,
  text,
  onRemove,
  label,
}: DynamicFilterInnerContentProps<T>) {
  label ||= filter.toLabel(filterProps);
  if (!items.length) return <p className='mt-[1px] select-none py-2 text-[13px] font-[500] text-gray-500'> {label}</p>;

  return (
    <div className='no-scrollbar flex select-none gap-1 overflow-y-hidden overflow-x-scroll py-1 text-gray-500'>
      {items.map(i => {
        const content = text ? text(i) : i;
        return (
          <div
            className={'ventory-border-color flex max-w-[120px] items-center whitespace-nowrap rounded-2 border p-1'}
            key={i}
          >
            <span title={content} className='mr-1 w-fit overflow-hidden text-ellipsis text-[12px] font-semibold'>
              {content}
            </span>
            <div
              onClick={event => {
                event.stopPropagation();
                onRemove(i);
              }}
              className={'flex h-[12px] w-[12px] items-center justify-center rounded-1 hover:bg-gray-100'}
            >
              <CloseIcon height={'6'} width={'6'} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
